var ICON_OK='<svg viewBox="0 0 14 16" width="14" height="16" aria-hidden="true"><path fill="#2B2B2B" d="M13.4 3.2 5.7 13.4a.9.9 0 0 1-1.4.1L.7 9.6a.9.9 0 1 1 1.3-1.2l2.9 3L12 2.1a.9.9 0 0 1 1.4 1.1Z"/></svg>';
var ICON_NO='<svg viewBox="0 0 14 16" width="14" height="16" aria-hidden="true"><path fill="#B9B3AA" d="M12.2 3.1 8.3 8l3.9 4.9a.9.9 0 1 1-1.4 1.1L7 9.4l-3.8 4.6a.9.9 0 1 1-1.4-1.1L5.7 8 1.8 3.1a.9.9 0 1 1 1.4-1.1L7 6.6l3.8-4.6a.9.9 0 1 1 1.4 1.1Z"/></svg>';

var TIERS=[
  {t:'Buy 1 Kit',       label:'30 Day Routine',  kits:1, price:68.99,  was:120,  ship:false},
  {t:'Buy 2 Get 1 Free',label:'3 Month Routine', kits:3, price:137.99, was:360,  ship:true},
  {t:'Buy 3 Get 2 Free',label:'5 Month Routine', kits:5, price:206.99, was:600,  ship:true},
  {t:'HARDER Monthly Cycle',label:'Monthly Cycle', kits:1, price:55.19, was:68.99, ship:false, sub:true}
];
var PERKS=[
  [1,'60-day money-back guarantee'],
  [1,'Discreet packaging, always'],
  [1,'Free shipping on orders over $60'],
  [1,'Ships before you run out']
];
var sel=2,$=function(i){return document.getElementById(i);};
function usd(n){return '$'+n.toFixed(2);}
function render(){
  if(!$('price')||!$('was')||!$('savepill'))return;
  var d=TIERS[sel],perKit=d.price/d.kits,perDay=perKit/30,off=Math.floor((1-d.price/d.was)*100);
  $('price').textContent=usd(d.price);
  $('was').textContent=usd(d.was);
  $('savepill').textContent='Save '+off+'%';
  $('perkit').innerHTML=usd(perKit)+' per kit &middot; '+usd(perDay)+' per day'+(d.ship?' &middot; '+d.kits+' kits shipped free':'');
  $('perks').innerHTML=PERKS.map(function(r){
    return '<li'+(r[0]?'':' class="no"')+'>'+(r[0]?ICON_OK:ICON_NO)+'<span>'+r[1]+'</span></li>';
  }).join('');
}
function harderSyncVariant(t){
  var q=document.getElementById('harderQty'),p=document.getElementById('harderPlan');
  if(!q||!t)return;
  if(t.dataset.qty)q.value=t.dataset.qty;
  if(p)p.value=t.dataset.plan||'';
}
harderSyncVariant(document.querySelector('.tier.on'));
[].forEach.call(document.querySelectorAll('.tier'),function(t){
  t.onclick=function(){
    [].forEach.call(document.querySelectorAll('.tier'),function(x){x.classList.remove('on');x.setAttribute('aria-checked','false');});
    t.classList.add('on');t.setAttribute('aria-checked','true');sel=+t.dataset.t;render();harderSyncVariant(t);
  };
});
if($('atc'))$('atc').onclick=function(){
  var n=+document.querySelector('.cart i').textContent+TIERS[sel].kits;
  [].forEach.call(document.querySelectorAll('.cart i'),function(c){c.textContent=n;});
  var lbl=$('atc').querySelector('.lbl'),old=lbl.textContent;
  lbl.textContent='Added \u2713';setTimeout(function(){lbl.textContent=old;},1200);
};
// product gallery
(function(){
  var stage=$('galStage'),thumbs=[].slice.call(document.querySelectorAll('.thumb'));
  var SRC={};for(var i=1;i<=7;i++)SRC[i]='var(--gal-'+i+')';
  thumbs.forEach(function(t){
    t.onclick=function(){
      thumbs.forEach(function(x){x.setAttribute('aria-selected','false');});
      t.setAttribute('aria-selected','true');
      stage.style.backgroundImage=SRC[t.dataset.g];
      stage.setAttribute('aria-label',t.getAttribute('aria-label'));
    };
  });
  var ft=$('factsToggle'),fw=$('factsWrap');
  if(ft&&fw)ft.onclick=function(){
    var open=fw.hidden;
    fw.hidden=!open; ft.setAttribute('aria-expanded',open);
    ft.textContent=open?'Hide supplement facts':'View supplement facts';
  };
})();
var burger=$('burger'),mm=$('mm'),fbMenu=$('fbMenu'),floatbar=$('floatbar');
function placeMenu(btn){var r=btn.getBoundingClientRect();mm.style.top=Math.round(r.bottom+10)+'px';mm.style.right=Math.round(Math.max(8,innerWidth-r.right))+'px';}
function toggleMenu(btn){var o=mm.classList.toggle('open');btn.setAttribute('aria-expanded',o);if(o){placeMenu(btn);}
  if(o){floatbar.classList.add('on');}else{settleBar();}}
burger.onclick=function(){toggleMenu(burger);fbMenu.setAttribute('aria-expanded','false');};
fbMenu.onclick=function(){toggleMenu(fbMenu);burger.setAttribute('aria-expanded','false');};
[].forEach.call(mm.querySelectorAll('a'),function(a){a.onclick=function(){
  mm.classList.remove('open');burger.setAttribute('aria-expanded','false');fbMenu.setAttribute('aria-expanded','false');settleBar();};});
document.addEventListener('click',function(e){
  if(mm.classList.contains('open')&&!mm.contains(e.target)&&!burger.contains(e.target)&&!fbMenu.contains(e.target)){
    mm.classList.remove('open');burger.setAttribute('aria-expanded','false');fbMenu.setAttribute('aria-expanded','false');settleBar();}
});
// the compact bar hides while you are moving and reappears once you stop,
// inverting whenever it settles over a dark band
var darkBands=[].slice.call(document.querySelectorAll('.band-dark')),idle=null;
function settleBar(){
  // the bar stays put while the menu is open, so the panel never floats on its own
  if(mm.classList.contains('open')){floatbar.classList.add('on');return;}
  if(window.scrollY<=240){floatbar.classList.remove('on');return;}
  var r=floatbar.getBoundingClientRect(),mid=r.top+r.height/2;
  floatbar.classList.toggle('on-dark',darkBands.some(function(bd){
    var x=bd.getBoundingClientRect();return x.top<mid&&x.bottom>mid;}));
  floatbar.classList.add('on');
}
function onScroll(){
  // with the menu open the bar rides along instead of ducking out from under it
  if(mm.classList.contains('open')){
    floatbar.classList.add('on');
    clearTimeout(idle);idle=setTimeout(settleBar,170);return;
  }
  if(floatbar.classList.contains('on')){floatbar.classList.remove('on');}
  clearTimeout(idle);
  idle=setTimeout(settleBar,170);
}
window.addEventListener('scroll',onScroll,{passive:true});
window.addEventListener('resize',onScroll);
if($('signupform'))$('signupform').onsubmit=function(e){e.preventDefault();e.target.querySelector('button').textContent='Check your inbox \u2713';};
// offer tab + claim modal
(function(){
  var tab=$('offerTab'),modal=$('offerModal'),panel=$('offerPanel'),closeB=$('offerClose'),photo=$('offerPhoto');
  if(!tab||!modal||!panel||!closeB)return;
  // reuse the hero photo rather than embedding the same image twice
  var hero=document.querySelector('.hero-photo img.shot');
  if(hero&&photo) photo.src=hero.currentSrc||hero.src;
  function open(){modal.classList.add('open');closeB.focus();document.body.style.overflow='hidden';}
  function close(){modal.classList.remove('open');document.body.style.overflow='';tab.focus();}
  tab.onclick=function(e){if(e.target.id==='offerTabX'){tab.hidden=true;return;}open();};
  closeB.onclick=close;
  if($('offerNo'))$('offerNo').onclick=close;
  modal.onclick=function(e){if(e.target===modal)close();};
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&modal.classList.contains('open'))close();});
  [].forEach.call(panel.querySelectorAll('.opts button'),function(b){
    b.onclick=function(){panel.classList.add('done');};
  });
  if($('offerGo'))$('offerGo').onclick=function(){close();};
})();
// day -> night scroll sequence: lines land, packs rise, packs split, copy arrives
(function(){
  var track=document.getElementById('dnTrack'),stage=document.getElementById('dnStage');
  if(!track||!stage)return;
  if(matchMedia('(prefers-reduced-motion:reduce)').matches)return;
  if(innerWidth<=700){

    // the gummies live in the empty gutters beside each pack, never over the copy
    var mfloats=[].slice.call(stage.querySelectorAll('.dn-float'));
    function placeFloats(){
      var sec=stage.parentElement.closest('section')||stage.parentElement;
      var sr=sec.getBoundingClientRect();
      var packs=[document.getElementById('pouchDay'),document.getElementById('pouchNight')].filter(Boolean);
      if(!packs.length)return;
      var pw=packs[0].getBoundingClientRect().width;
      var gutter=Math.max(0,(sr.width-pw)/2);
      var w=Math.max(40,Math.min(74,gutter*0.74));
      var spots=[];
      packs.forEach(function(pk,pi){
        var pr=pk.getBoundingClientRect(), top=pr.top-sr.top;
        var order=pi===0?['left','right','left']:['right','left','right'];
        [0.06,0.44,0.80].forEach(function(f,i){spots.push({side:order[i],y:top+pr.height*f});});
      });
      mfloats.forEach(function(f,i){
        var sp=spots[i%spots.length]; if(!sp)return;
        f.style.width=w+'px'; f.style.height='auto';
        f.style.top=Math.round(sp.y)+'px';
        if(sp.side==='left'){f.style.left=Math.round(Math.max(2,gutter*0.10))+'px';f.style.right='auto';}
        else{f.style.right=Math.round(Math.max(2,gutter*0.10))+'px';f.style.left='auto';}
      });
    }
    placeFloats();
    addEventListener('resize',placeFloats);
    addEventListener('load',placeFloats);
    setTimeout(placeFloats,600);
    var lines=[].slice.call(document.querySelectorAll('#dnLines span'));
    var stack=[document.getElementById('dnEyebrow'),
               document.getElementById('pouchDay'),document.getElementById('copyDay'),
               document.getElementById('pouchNight'),document.getElementById('copyNight'),
               document.getElementById('dnTie')].filter(Boolean);
    stack.concat(lines).forEach(function(e){e.classList.add('mrv');e.style.opacity='';e.style.transform='';});
    var mio=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting)return;
        e.target.classList.add('in'); mio.unobserve(e.target);
      });
    },{threshold:.2,rootMargin:'0px 0px -8% 0px'});
    stack.forEach(function(e){mio.observe(e);});
    // the four lines land one after another instead of all at once
    var lineBox=document.getElementById('dnLines');
    if(lineBox){
      var lio=new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(!e.isIntersecting)return;
          lines.forEach(function(sp,i){setTimeout(function(){sp.classList.add('in');},i*150);});
          lio.disconnect();
        });
      },{threshold:.15,rootMargin:'0px 0px -12% 0px'});
      lio.observe(lineBox);
    }
    return;
  }
  var linesEl=document.getElementById('dnLines'),
      spans=[].slice.call(linesEl.querySelectorAll('span')),
      eyebrow=document.getElementById('dnEyebrow'),
      pDay=document.getElementById('pouchDay'), pNight=document.getElementById('pouchNight'),
      cDay=document.getElementById('copyDay'),  cNight=document.getElementById('copyNight'),
      tie=document.getElementById('dnTie'),
      floats=[].slice.call(stage.querySelectorAll('.dn-float')),ticking=false;
  var DAY=[231,154,125],MID=[239,195,158],LIGHT=[242,228,181],INK=[43,43,43],ACCENT=[168,52,42];
  function mix(a,b,t){return [0,1,2].map(function(i){return Math.round(a[i]+(b[i]-a[i])*t);});}
  function rgb(c){return 'rgb('+c.join(',')+')';}
  function cl(v,a,b){return Math.max(a,Math.min(b,v));}
  function ease(t){return t<0.5 ? 2*t*t : 1-Math.pow(-2*t+2,2)/2;}

  function frame(){
    var r=track.getBoundingClientRect(),vh=window.innerHeight;
    var p=cl(-r.top/(r.height-vh),0,1);

    var cp=cl(p/0.72,0,1);
    stage.style.background = cp<0.5 ? rgb(mix(DAY,MID,cp/0.5)) : rgb(mix(MID,LIGHT,(cp-0.5)/0.5));

    eyebrow.style.color=rgb(INK);
    eyebrow.style.opacity=(1-cl((p-0.24)/0.10,0,1));

    // 1. lines land one by one, then clear
    var out=cl((p-0.40)/0.10,0,1);
    spans.forEach(function(sp,i){
      var t=cl((p-(0.04+i*0.065))/0.05,0,1);
      sp.style.opacity=(t*(1-out)).toFixed(3);
      sp.style.transform='translateY('+(((1-t)*34)-(out*60)).toFixed(1)+'px)';
      sp.style.color=(i===spans.length-1 && p>0.27) ? rgb(ACCENT) : rgb(INK);
    });

    // 2. packs rise into the centre   3. then split to the margins and shrink
    var rise=ease(cl((p-0.14)/0.34,0,1));
    var split=ease(cl((p-0.52)/0.26,0,1));
    var sw=stage.clientWidth, pw=pDay.offsetWidth||160;
    var scale=1.15-split*0.53;
    var pairX=pw*0.56;                                   // side by side, centred
    var sideX=sw*0.5-(pw*scale)*0.5-sw*0.045;            // out to the margins
    var x=pairX+(sideX-pairX)*split;
    var sh=Math.min(vh,900);
    var yPx=(1-rise)*(sh*0.78);                          // up from below the fold
    pDay.style.transform  ='translate(calc(-50% - '+x.toFixed(1)+'px), calc(-50% + '+yPx.toFixed(1)+'px)) scale('+scale.toFixed(3)+')';
    pNight.style.transform='translate(calc(-50% + '+x.toFixed(1)+'px), calc(-50% + '+yPx.toFixed(1)+'px)) scale('+scale.toFixed(3)+')';

    // 4. copy arrives beside each pack, on the same centre line
    var copyIn=cl((p-0.60)/0.16,0,1);
    var slide=Math.min(26,innerWidth*0.035);
    cDay.style.opacity=copyIn;   cDay.style.transform  ='translate('+((1-copyIn)*-slide).toFixed(1)+'px,-50%)';
    cNight.style.opacity=copyIn; cNight.style.transform='translate('+((1-copyIn)*slide).toFixed(1)+'px,-50%)';

    // 5. the line that ties them together
    var tieIn=cl((p-0.78)/0.14,0,1);
    tie.style.opacity=tieIn; tie.style.transform='translateY('+((1-tieIn)*26).toFixed(1)+'px)';

    floats.forEach(function(f){
      var sp=parseFloat(f.dataset.speed)||1,rot=parseFloat(f.dataset.rot)||0;
      f.style.transform='translate3d(0,'+((p-0.5)*sp*300).toFixed(1)+'px,0) rotate('+(rot+(p-0.5)*sp*24).toFixed(1)+'deg)';
      f.style.opacity=(1-cl((p-0.50)/0.18,0,1)).toFixed(2);
    });

    ticking=false;
  }
  function req(){if(!ticking){ticking=true;requestAnimationFrame(frame);}}
  window.addEventListener('scroll',req,{passive:true});
  window.addEventListener('resize',req);
  frame();
})();
render();

// phone-only sticky buy bar: appears once the hero is behind you, steps aside at the buy box
(function(){
  if(innerWidth>700)return;
  if(document.getElementById('hdrMcta'))return;
  var buy=document.querySelector('#buy');
  var bar=document.createElement('div');
  bar.id='hdrMcta';
  bar.className='mcta';
  bar.innerHTML='<a href="#buy">SAVE 65% + FREE SHIPPING</a>';
  (document.querySelector('.hdr')||document.body).appendChild(bar);
  function place(){
    var past=window.scrollY>420, atBuy=false;
    if(buy){var r=buy.getBoundingClientRect();atBuy=r.top<innerHeight*0.75&&r.bottom>innerHeight*0.25;}
    bar.classList.toggle('on',past&&!atBuy);
  }
  addEventListener('scroll',place,{passive:true});addEventListener('resize',place);place();
})();
